module.exports = __webpack_public_path__ + "img/white.3f2ef019.png";